import React from "react";
import { Outlet } from "react-router-dom";
import { TopBar } from "@/components/TopBar";
import { BottomNav } from "@/components/BottomNav";

export function AppShell({ title }) {
  return (
    <div
      className="mx-auto w-full max-w-md relative"
      style={{ background: "#0A0D14", minHeight: "100svh" }}
    >
      <TopBar title={title} />
      <main
        className="px-0"
        style={{ paddingBottom: "calc(5rem + env(safe-area-inset-bottom))" }}
      >
        <Outlet />
      </main>
      <BottomNav />
    </div>
  );
}
